
import ImageHeader from '@/components/core/ImageHeader';
import tableLoading from '@/components/tableLoading';
import NoContent from '@/components/customer-content/NoContent'
import CouponSlick from '@/components/CouponSection/CouponSlick'
import Coupon from '@/components/CouponSection/Coupon'
import ActivityCard from "@/components/ActivityCard.vue";

export default {
  scrollToTop: true,
  components: {
    ImageHeader,
    tableLoading,
    NoContent,
    CouponSlick,
    Coupon,
    ActivityCard
  },
  head() {
    return {
      title: this.title + " | Goa App",
      meta: [{
          hid: 'description',
          name: 'description',
          content: this.description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.keywords
        },
        { hid: 'image',
        property: 'image',
        content: this.metaImage
},
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title + " | Goa App"
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.description
        },
        { hid: 'og:image',
        property: 'og:image',
        content: this.metaImage
        },
        {
          hid: 'og:image:secure_url',
          property: 'og:image:secure_url',
          content: this.metaImage
        },
        { hid: 'og:image:alt',
          property: 'og:image:alt',
          content: this.title
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title + " | Goa App"
        },
        { hid: 'twitter-image',
        property: 'twitter:image',
        content: this.metaImage
},
        {
          hid: 'twitter:description',
          property: 'twitter:description',
          content: this.description
        }

      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      title: 'Top Activities and Offers',
      description: 'Goa App | Discover Beaches, Churches, Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals in Goa.',
      keywords: '',
      metaImage: '',
      selectedValue: null,
      search: '',
      eventCategoryModal: false,
      isSearchClicked: false,
      pageData: {
        categories: null,
        activities: null
      },
      filters: {
        categories: [],
        allCategory: true,
        sortBy: 'popular',
      },
      applyFilterClicked: false,
      skip: 0,
      page: 1,
      totalNumberOfpages: 0,
      listings: {},
      itemSelected: -1,
      schemaData: [],
      loading: true,
      listingLoading: true,
      coupons: null,
      activityCat: null,
      pageTitle: 'Activities',
      pageSubTitle: 'Popular Adventure Tourism Activities in Goa',
      apiCallName: null,

      busy: false,
      productObj:[],
      eventCategoryModal: false,
      featuredCats: null,
      featuredCatsLoading: true,
      interLinks: {
        "title": "Explore More on Goa App",
        "links": [
          {"sub_title":"Top Activities",
          "interLinks":[
          {
            "name":"Trending in Goa",
            "url":"/experiences/must-do-activities"
          },
          {
            "name":"Top Sellers Activities",
            "url":"/experiences/top-sellers"
          },
          {
            "name":"Romantic Couple Activities",
            "url":"/experiences/couple-friendly-activities"
          },
          {
            "name":"Watersports Activities",
            "url":"/experiences/outdoor-adventures-and-watersports"
          },
          {
            "name":"Couple photography",
            "url":"/experiences/goa-photoshoot-packages"
          }

          ]},
          {"sub_title":"Must-see popular attractions",
          "interLinks":[{
            "name":"Beaches in Goa",
            "url":"/goa/beaches"
          },
          {
            "name":"Nightlife in Goa",
            "url":"/goa/nightlife"
          },
          {
            "name":"Watersports in Goa",
            "url":"/goa/activities/category/water-sports"
          },
          {
            "name":"Heritage in Goa",
            "url":"/goa/religious-places"
          },
          {
            "name":"Restaurants in Goa",
            "url":"/restaurants"
          },
          {
            "name":"Casino in Goa",
            "url":"/goa/activities/category/entertainment"
          }
          ]},

          {"sub_title":"More on Goa App",
          "interLinks":[{
            "name":"Hire a Taxi",
            "url":"/taxi"
          },
          {
            "name":"Rent a Car",
            "url":"/rentals"
          },
          {
            "name":"Restaurants offers",
            "url":"/offers"
          },
          {
            "name":"Holiday Packages",
            "url":"/packages"
          },
          {
            "name":"Upcoming Events",
            "url":"/events"
          }


          ]}
        ]
      }

    };
  },
  async validate({
    params,
    store
  }) {
    // await operations
    if (params.slug != (null || "")) {
      this.activityCat = params.category;
      return true // if the params are valid
    } else {
      return false // will stop Nuxt.js to render the route and display the error page
    }
  },
  created() {
    this.activityCat = this.$route.params.category;
    if (this.activityCat) {
      let activity = this.activityCat.toLowerCase().trim();
      switch (activity) {
        case 'top-sellers':
          this.pageTitle = 'Top Sellers';
          this.pageSubTitle = 'Activities choosen by most of the travellers on their trip to Goa.';
          this.apiCallName = 'getAllTopSellers';
          this.title = 'Top selling activities in Goa';
          this.metaImage = this.$config.siteUrl + '/img/top-sellers.jpg';
          this.description = 'Activities choosen by most of the travellers on their trip to Goa.';
          this.keywords = "unique things to do in goa, activities to do in goa, activities in goa with price, top 10 places to visit in goa, hot things to do in goa, top activities in goa, local activities in goa, recreational activities in goa, goa activities to do, goa activities packages";
          break;
        case 'must-do-activities':
          this.pageTitle = 'Things to Do';
          this.pageSubTitle = 'Activities Starting from ₹299';
          this.apiCallName = 'getAllfeaturedActivities';
          this.title = 'Unlock your Goa journey with Goa App';
          this.metaImage = this.$config.siteUrl + '/img/must-do-activities.jpg';
          this.description = 'Experiences handpicked by our staff to enrich your vacation.';
          this.keywords = "visiting goa, things to do in goa during covid, things to do in goa, sightseeing in goa by car, goa bucket list, things to do in goa in December 23, things not to miss in goa, handpicked activities for you goa in hindi, goa activities packages, local activities in goa, activities goa";
          break;
        case 'couple-friendly-activities':
          this.pageTitle = 'Couple Friendly Activities';
          this.pageSubTitle = 'Couple and family friendly activities.';
          this.apiCallName = 'getAllCoupleFriendlyActivities';
          this.title = 'Things To Do In Goa For Couples That Go Beyond The Beach';
          this.metaImage = this.$config.siteUrl + '/img/couple-friendly-activities.jpg';
          this.description = 'Couple and family friendly activities.';
          this.keywords = "best area to stay in goa for couples, places to visit in goa for couples, places to visit in goa in 3 days for couples, private places in goa, unique things to do in goa, is goa safe for married couples, couple friendly places in goa, couple activities in goa, couple friendly resorts in goa, couple friendly rooms in goa, couple friendly hotels in goa, couple friendly activities near margao goa, couple friendly activities near goa";
          break;
        case 'outdoor-adventures-and-watersports':
          this.pageTitle = 'Outdoor Adventures';
          this.pageSubTitle = 'Thrilling Adventues and watersports to enjoy with your gang';
          this.apiCallName = 'getAllGroupAdctivities';
          this.title = 'Adventure Activities in Goa at Best Price';
          this.metaImage = this.$config.siteUrl + '/img/outdoor-adventures-and-watersports.jpg';
          this.description = 'Thrilling Adventues and watersports to enjoy with your gang';
          this.keywords = "outdoor adventures near margao goa, outdoor adventures near goa, outdoor adventures near me, outdoor adventure activities list, crazy adventures, adventure activities in goa with price, adventure sports in goa, goa adventure sports packages, activities in goa beach, adventure sports in south goa, goa adventure park, goa adventure packages, goa adventure activities, goa adventure trip, goa adventure activities packages";
          break;
        case 'goa-monsoon-activities':
          this.pageTitle = 'Monsoon Activities';
          this.pageSubTitle = 'Experience a wide range of monsoon activities in Goa, including water sports, river rafting, trekking, and nature exploration. Plan your thrilling rainy season adventure in Goa today!';
          this.apiCallName = 'getAllMonsoonActivities';
          this.title = 'Must try Monsoon Activities in Goa at Best Price';
          this.metaImage = this.$config.siteUrl + '/img/monsoon-activities.jpg';
          this.description = 'Experience a wide range of monsoon activities in Goa, including water sports, trekking, and nature exploration. Plan your thrilling rainy season adventure in Goa today!';
          this.keywords = "monsoon activities, Goa, water sports, trekking, nature exploration, rainy season adventure";
          break;
          case 'goa-photoshoot-packages':
          this.pageTitle = 'Goa Photoshoot Packages';
          this.pageSubTitle = 'Capture Memorable Moments with Our Stunning Goa Photoshoot Packages';
          this.apiCallName = 'getAllPhotographyPackages';
          this.title = 'Photoshoot Packages in Goa | starts @₹4,999 only';
          this.metaImage = this.$config.siteUrl + '/img/goa-photoshoot-package.jpg';
          this.description = 'Capture Memorable Moments with Our Stunning Goa Photoshoot Packages. Packages start from ₹4,999 only.';
          this.keywords = "Goa photoshoot packages, Professional photoshoot in Goa Affordable Goa photography, Best Goa photographers, Beach photoshoot in Goa, Candid photography in Goa, Pre-wedding photoshoot Goa, Family photoshoot packages Goa, Goa destination photography, Top photographers in Goa, Goa honeymoon photoshoot, Travel photography in Goa, Photoshoot deals in Goa, Goa photoshoot prices, Photography services Goa";
          break;
        default:
          this.$router.push({
            path: '/'
          });
      }
    } else {
      this.$router.push({
        path: '/'
      });
    }
  },
  fetchOnServer: false,
  async fetch() {

    //call the api to get featured coupons
    this.coupons = await fetch(this.$config.fetchUrl + '/api/coupons/app/featuredCoupons').then(res => res
      .text());
      this.coupons = this.getCryptKey(this.coupons);
    //Get the list of page data
    this.pageData.categories = await fetch(this.$config.fetchUrl +
      '/api/activityTypes/app/getTypeDetails/activities').then(res => res.text());
      this.pageData.categories = this.getCryptKey(this.pageData.categories);
  },

  jsonld() {
    return {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: this.schemaData.map((itm, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          "name": itm.post && itm.post.title ? itm.post.title : 'Goa App',
          "description": itm.post && itm.post.description ? itm.post.description : 'One of the things you must do in Goa.',
          "image": itm.post && itm.post.gallery && itm.post.gallery.length > 0 ? itm.post.gallery : [],
          "brand": {
            "@type": "Brand",
            "name": "Goa App"
          },
          "review": [{
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": 5
          },
          "author": {
            "@type": "Person",
            "name": "Sanjeet Shet"
          }
        },
        {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": 4
          },
          "author": {
            "@type": "Person",
            "name": "Diptesh Kamat"
          }
      }],
          "aggregateRating": {
            "@type": "AggregateRating",
            "bestRating": "150",
            "ratingCount": "189",
            "ratingValue": '88'
          },
          "offers": {
            "@type": "Offer",
            "price": itm.seller ? this.activityDiscountPrice(itm.seller) : 0,
            "priceValidUntil": "2025-12-31",
            "priceCurrency": "INR",
            "availability": "InStock",
            "seller": {
              "@type": "Organization",
              "name": "Goa App"
            },
            "hasMerchantReturnPolicy": {
              "@type": "MerchantReturnPolicy",
              "applicableCountry": "IN",
              "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
              "merchantReturnDays": 10,
              "returnMethod": "https://schema.org/ReturnByMail",
              "returnFees": "https://schema.org/FreeReturn"
            },
            "shippingDetails": {
              "@type": "OfferShippingDetails",
              "deliveryTime": {
                  "@type": "ShippingDeliveryTime",
                  "businessDays": {
                      "@type": "OpeningHoursSpecification",
                      "dayOfWeek": [
                          "https://schema.org/Monday",
                          "https://schema.org/Tuesday",
                          "https://schema.org/Wednesday",
                          "https://schema.org/Thursday",
                          "https://schema.org/Friday"
                      ]
                  },
                  "cutoffTime": "12:00:15Z",
                  "handlingTime": {
                      "@type": "QuantitativeValue",
                      "minValue": 1,
                      "maxValue": 2,
                      "unitCode": "d"
                  },
                  "transitTime": {
                      "@type": "QuantitativeValue",
                      "minValue": 1,
                      "maxValue": 10,
                      "unitCode": "d"
                  }
              },
              "shippingRate": {
                "@type": "MonetaryAmount",
                "value": "0",
                "currency": "INR"
              },
              "shippingDestination": [
                {
                  "@type": "DefinedRegion",
                  "addressCountry": "IN",
                  "addressRegion": ["GA"]
                }
              ]
            }
          }
        },
      })),
    };
  },

  mounted() {
    document.body.classList.add('modalOverflow');
    this.getActitvitesCategoriesData();
    let searchedCategory = this.$route.query.category ?
      this.$route.query.category :
      null;
    var self = this;
    if (searchedCategory) {
      if (Array.isArray(searchedCategory)) {
        searchedCategory.forEach(function(value, index) {
          self.filters.categories.push(value);
        });
      } else {
        this.filters.categories.push(searchedCategory);
      }

      this.filters.allCategory = false;
    }

    if(localStorage.getItem("activitiesFilter")){
      this.listingLoading=false; this.restoreFilters();
    }
    else{
      window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
    let pagination = (this.page - 1) * 12;
    if (pagination < 0) {
      pagination = 0;
    }
    this.getListings(pagination, this.search, this.filters.sortBy, this.filters.categories);
    this.$parent.$emit("sentInterLinks", this.interLinks);
  }

  },
  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },
  computed: {
    disableSearch() {
      let searchStr = "";
      if (this.search)
        searchStr = this.search.trim()
      const re = /^[a-zA-Z0-9\s,-]{3,}/;
      return re.test(String(searchStr).toLowerCase());
    }
  },
  methods: {
    loadMore() {
      this.busy = false;
      if(this.listings.isMoreDataAvailable){
      this.busy = true;

      setTimeout(() => {
        this.page++
        this.callback(this.page)

      }, 1000);
    }
    },
    categoryChecked(id) {
      return this.filters.categories.includes(id)
    },
    // Store filters in Localstorage
    restoreFilters() {
      let filters = null
      if (localStorage.getItem("activitiesFilter")) {
        filters = JSON.parse(localStorage.getItem("activitiesFilter"))
        this.search = filters.search;
        this.filters.sortBy = filters.sortBy;
        this.filters.categories = filters.categories;
        if (filters.categories.length > 0) {
          this.filters.allCategory = false;
        }
        this.page = filters.page;
        this.listings = filters.listings;
        this.productObj = filters.productObj;
        this.itemSelected = filters.itemSelected;
        this.scrollToJs(this.itemSelected )
      }
    },
    // Store filters in Localstorage
    storeFilters() {
      let filters = {
        search: this.search,
        sortBy: this.filters.sortBy,
        page: this.page,
        categories: this.filters.categories,
        listings: this.listings,
        productObj: this.productObj,
        itemSelected: this.itemSelected,
      }
      localStorage.setItem("activitiesFilter", JSON.stringify(filters));
    },
    getActivityId(value){
      if(value){
        this.itemSelected = value;
        this.storeFilters();
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },

    activityDiscountPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
        return seller[0].tickets[0].prices[0].price
      }
      return 0
    },
    
    categoryAll() {
      this.filters.categories = [];
      this.filters.allCategory = true;
    },
    // callback for the pagination plugin
    callback: function(page) {
      this.page = page;
      this.storeFilters();
      let pagination = (page - 1) * 12;
      if (pagination < 0) {
        pagination = 0;
      }
      //this.scrollToElement('listing-list');
      if ((this.search && this.isSearchClicked) || (this.filters.sortBy && this.filters.sortBy != "popular") || (
          this
          .filters.categories && this.filters.categories.length > 0)) {
        this.getListings(pagination, this.search, this.filters.sortBy, this.filters.categories);
      } else {
        this.getListings(pagination);
      }
    },
    // TO get SUBSCRIPTIONS using pagination
    getListings(skip, queryStr = null, sortBy = null, categories = null) {
      //this.listingLoading = true;
      var formData = new URLSearchParams();
      formData.append("skip", skip);
      if (queryStr)
        formData.append("query", queryStr.trim());
      if (sortBy)
        formData.append("sortBy", sortBy.trim());
      if (categories != null && categories.length > 0) {
        categories.forEach(category => {
          formData.append('categories', category);
        })
      }

      //For get activities api
      if (categories != null && categories.length > 0) {
        categories = encodeURIComponent(JSON.stringify(categories));
      } else {
        categories = ['all']
      }

      // Add header for the API
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      // AXIOS api call to add review api
      // this.$axios.post("/api/posts/app/getPostsOfType/activities", formData, {
      //     headers: headers
      //   })
      this.$axios.get(
          `/api/posts/app/${this.apiCallName}/activities/${queryStr ? queryStr.trim() : 'search'}/${skip}/${categories}/${sortBy ? sortBy : 'popular'}`
        )
        .then(response => {
          this.applyFilterClicked = false;
          this.busy = false;
          if (queryStr)
            this.isSearchClicked = true;
            let value = this.getCryptKey(response.data);
          this.listings = value;
          this.productObj.push(...value.posts)
          this.schemaData = this.listings && this.listings.posts ? this.listings.posts : [];
          if (skip == 0) {
            this.page = 1;
          }
          this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 12);
          document.getElementById('filterClose').click();
          this.$nextTick(() => {
            //this.scrollToSectionIntoView('listing-card');
            this.listingLoading = false;
            this.applyFilterClicked = false;
          })
        })
        .catch(error => {
          this.$nextTick(() => {
            this.listingLoading = false;
            this.applyFilterClicked = false;
          })
        })
        .finally(() => {
          this.$nextTick(() => {
            //this.scrollToSectionIntoView('listing-card');
            // window.scrollTo({
            //   top: 0,
            //   behavior: 'smooth'
            // });
            this.listingLoading = false;
            this.applyFilterClicked = false;
          })
        })
    },
    // Hide/Show clear Button
    showClearBtn() {
      if ((this.search && this.isSearchClicked) || (this.filters.sortBy && this.filters.sortBy != "popular") || (!this
          .filters.allCategory && this.filters.categories.length > 0))
        return true
      return false
    },
    // Clear all dates, search and filters on click
    clearAll() {
      this.filters.categories = [];
      this.filters.allCategory = true;
      this.filters.sortBy = 'popular';
      this.search = '';
      this.isSearchClicked = false;
    },
    async getActitvitesCategoriesData() {
        this.featuredCatsLoading = true;
        this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForActivityPageWithSlug').then(res =>
          res
          .text());
        this.featuredCats = this.getCryptKey(this.featuredCats);
        this.featuredCatsLoading = false;
      },
    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    }
  }
}
